<div
  class="settings-bar"
  role="toolbar"
  aria-label="User settings"
>

  @if (!headerResponsivenessOptions.hideColorCodeLegend) {
    <app-colorcode-legend />
  }

  <lib-theme-switch />

  @if (isDevMode && !headerResponsivenessOptions.hideColorCodeLegend) {
    <app-language-switch [headerResponsivenessOptions]="headerResponsivenessOptions" class="font-weight-bold text-primary" />
  }

  <app-bell-switch />

  @if (!headerResponsivenessOptions.hideTimezoneSwitch) {
    <app-timezone-switch [headerResponsivenessOptions]="headerResponsivenessOptions" />
  }

  <app-user-box [headerResponsivenessOptions]="headerResponsivenessOptions"/>
</div>
